import React, { FC } from 'react';
import { IGatsbyImageData } from 'gatsby-plugin-image';
import ImageWithFallback from '../ImageWithFallback';

interface GatsbyImageProps {
  image?: {
    readonly childImageSharp: {
      readonly gatsbyImageData: IGatsbyImageData;
    } | null;
  } | null;
  alt?: string | null;
  width?: string | number;
  height?: string | number;
  style?: React.CSSProperties;
  [s: string]: unknown;
}

interface StringImageProps {
  image: string;
  alt: string;
  width?: string | number;
  height?: string | number;
  style?: React.CSSProperties;
  [s: string]: unknown;
}

type Props = GatsbyImageProps | StringImageProps;

const Image: FC<Props> = (props) => {
  const { image, alt, width, height, style, ...rest } = props;

  if (!image || !alt) return null;

  if (typeof image === 'string') {
    return (
      <ImageWithFallback
        src={image}
        alt={alt}
        width={width}
        height={height}
        style={style}
        {...rest}
      />
    );
  }

  if (!image?.childImageSharp?.gatsbyImageData) return null;

  const { gatsbyImageData } = image.childImageSharp;
  const imageSrc = gatsbyImageData.images?.fallback?.src || '';

  return (
    <ImageWithFallback
      src={imageSrc}
      alt={alt}
      width={width || gatsbyImageData.width}
      height={height || gatsbyImageData.height}
      style={style}
      {...rest}
    />
  );
};

export default Image;
